import { IAutoEnrollmentApplication } from '@sureapp/platform-sdk';
import Button from '@sureapp/wl-toggle-common/dist/components/Button';
import Spinner from '@sureapp/wl-toggle-common/dist/components/Spinner';
import moment from 'moment-timezone';

import LayoutContent from '@@/auto/components/LayoutContent';
import { useQAStartScreenContext } from '@@/common/containers/__qa_only__/QAStartScreensContainer/qaStartScreensContext';

import classes from './QAAutoQuickPurchaseScreen.module.css';

const enrollmentApplication: IAutoEnrollmentApplication = {
  firstName: 'DELLA',
  lastName: 'DURIGA',
  dob: '1964-06-11',
  address: {
    city: 'GREENVILLE',
    line1: '2706 OLD EASLEY BRIDGE RD',
    line2: null,
    region: {
      code: 'SC',
      name: 'South Carolina',
    },
    postal: '29611',
    country: {
      name: 'United States',
      code: 'US',
    },
    timezone: 'America/New_York',
  },
  coverageEffectiveDate: moment.utc().format('YYYY-MM-DD'),
  selfReportedIncidentCount: 0,
};

function QAQuickPurchaseScreen() {
  const { createQuote, isSubmittingQuickQuote } = useQAStartScreenContext();

  return (
    <LayoutContent
      header="Quick Purchase"
      hideFooter
      subHeader="Click on Quick Purchase button to create quote, it will direct you to review quote screen"
      overrideClasses={{
        root: classes.root,
      }}
    >
      {isSubmittingQuickQuote ? (
        <Spinner data-testid="qa_quickPurchase_spinner" />
      ) : (
        <Button
          data-testid="qa_quickPurchase_button"
          onClick={() => createQuote(enrollmentApplication)}
          label="Quick purchase"
        />
      )}
    </LayoutContent>
  );
}

export default QAQuickPurchaseScreen;
